module.exports = __webpack_public_path__ + "img/17ne.2ad05cd5.svg";